export default "__VITE_ASSET__TNr6GOJg__"